import {
  Lit3formBlock,
  html,
  unsafeHTML,
  icon,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsCtaDataObject,
  analyticsLabelFromString,
  handleFileDownloadEvent,
} from '../../../helpers/adobe-analytics';

export class Doug extends Lit3formBlock {
  static get characterName() {
    return 'doug';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid doug-layout">
          ${this.headerText
            ? html`
                <h2 class="header">${unsafeHTML(this.headerText)}</h2>
              `
            : ``}
          ${this.descriptionText
            ? html`
                <p class="description details-row">
                  ${unsafeHTML(this.descriptionText)}
                </p>
              `
            : ``}
          <span class="images" id="doug-images">
            ${this.imagesArr.map((i, index) => this.imageHTML(i[1], index))}
          </span>
          <span
            class="arrow left-arrow"
            @click="${() => this.sideScroll('left')}"
          >
            ${icon('arrow')}
          </span>
          <span
            class="arrow right-arrow"
            @click="${() => this.sideScroll('right')}"
          >
            ${icon('arrow')}
          </span>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image, index) {
    return !!image.description
      ? html`
          <div class="image-wrapper">
            <a
              class="image download-cursor"
              href=${this.imageHref(image)}
              rel="noopener"
              id=${`image-index-${index}`}
              @click="${() => this.handleImageDownload(image)}"
            >
              <img src=${this.imageUrl(image)} />
            </a>
            <p class="image-description font-size-small">
              ${unsafeHTML(this.withLineBreaks(image.description))}
            </p>
          </div>
        `
      : html`
          <div class="image-wrapper">
            <div class="image">
              <img src=${this.imageUrl(image)} />
            </div>
          </div>
        `;
  }

  sideScroll(direction) {
    const wrapperElement = this.shadowRoot.getElementById('doug-images');
    let scrollAmount = 0;
    const step = 40;
    const distance = wrapperElement.getBoundingClientRect().width;
    const slideTimer = setInterval(function() {
      direction === 'left'
        ? (wrapperElement.scrollLeft -= step)
        : (wrapperElement.scrollLeft += step);
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, 10);
  }

  handleImageDownload(image) {
    const downloadData = {
      file_format: 'JPG',
      file_name: analyticsLabelFromString(image.description || this.headerText),
      link_url: this.imageHref(image),
      link_type: 'IMAGE',
      placement: analyticsLabelFromString(this.headerText),
    };
    handleFileDownloadEvent(analyticsCtaDataObject(downloadData));
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return this.imagebossUrl(image.src, null, 400);
  }
}
Doug.defineElement();
